const hideProgressModal = ({ dispatch }) => {
  dispatch('progressModal/hideProgressModal', {}, { root: true })
}

export default hideProgressModal
